import { Fragment, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import JoditEditor from "jodit-react";
import { stringToSlug } from "components/Function";

function ModalForm({ formData, onSubmit, onClose, isOpen, title }) {
    const [data, setData] = useState();
    const { t } = useTranslation();
    const config = useMemo(() => {
        return {
            placeholder: "",
            height: "500px",
        };
    }, []);

    useEffect(() => {
        if (formData) setData(formData);
    }, [formData]);

    useEffect(() => {
        if (!isOpen) setData({});
    }, [isOpen]);

    const handleSave = () => {
        const form = data;
        if (formData?._id) form.id = formData?._id;
        onSubmit?.(form);
    };

    const handleSlugChange = (value) => {
        const slug = stringToSlug(value);
        setData((prev) => ({ ...prev, slug }));
    }

    const handleTitleChange = (value) => {
        const slug = stringToSlug(value);
        setData((prev) => ({ ...prev, title: value, slug }));
    }

    return (
        <Fragment>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t(title)}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Title")}</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={data?.title || ""}
                            placeholder={t("Title")}
                            name="title"
                            onChange={(e) => {
                                handleTitleChange(e.target.value);
                            }}
                        />
                    </div>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Slug")}</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={data?.slug || ""}
                            placeholder={t("Slug")}
                            name="slug"
                            onChange={(e) => {
                                handleSlugChange(e.target.value);
                            }}
                        />
                    </div>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Status")}</span>
                        </label>
                        <select
                            className="form-select"
                            data-control="select2"
                            data-hide-search="true"
                            data-placeholder="Select a Status"
                            value={data?.status || "ACTIVE"}
                            onChange={(e) => {
                                setData((prev) => ({ ...prev, status: e.target.value }));
                            }}
                        >
                            <option value="ACTIVE">Active</option>
                            <option value="DISABLE">Disable</option>
                        </select>
                    </div>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Content")}</span>
                        </label>
                        <JoditEditor
                            value={formData?.content || ""}
                            config={config}
                            tabIndex={1}
                            onBlur={(newDescription) => setData((prev) => ({ ...prev, content: newDescription }))}
                            onChange={(newDescription) => {}}
                            maxHeight={200}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                        onClick={() => {
                            handleSave();
                        }}
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalForm);
